import UploadPostContainer from "./UploadPostContainer";
export default UploadPostContainer;
